import { UserRoleName } from 'domain/UserProfile';
import i18n from 'i18n';

type UserRoleNameLiteral = `${(typeof UserRoleName)[keyof typeof UserRoleName]}`;

export const mapUserRoleToLabel = (role: UserRoleName | UserRoleNameLiteral) => i18n.t(`community:roles.${role}`);
